import { useEffect, useMemo } from "react";
import { ID_ATRIBUTO_BATERIA_TIPO_CHUMBO, ID_ATRIBUTO_BATERIA_TIPO_LITIO } from "src/components/projetos/constants";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import { Bateria, FormProjetoOffGridType, TiposBaterias } from "../../../types";
import { InputPrefix } from "./InputPrefix"
import { OPCOES_REMOVER_LITIO } from "./TensaoSaidaInput";

interface CiclosBateriasInputProps {
  errorState: string[];
  formState: FormProjetoOffGridType;
  onChangeValue: (formState: Partial<FormProjetoOffGridType>) => void;
}

export const TIPOS_BATERIAS_OPTIONS: { id: TiposBaterias; nome: string; }[] = [
  {
    nome: "Chumbo",
    id: "chumbo"
  },
  {
    nome: "Lítio",
    id: "litio"
  }
]

const getTiposPermitidos = (baterias: Bateria[]): TiposBaterias[] => {
  const bateriasLitio = baterias.some(bt => bt.tipo === ID_ATRIBUTO_BATERIA_TIPO_LITIO)
  const bateriasChumbo = baterias.some(bt => bt.tipo === ID_ATRIBUTO_BATERIA_TIPO_CHUMBO)

  if (bateriasLitio && !bateriasChumbo) {
    return ["litio"]
  }
  if (bateriasChumbo && !bateriasLitio) {
    return ["chumbo"]
  }
  return ["litio", "chumbo"]
}

const checarBaterias = (baterias: Bateria[], tipo_bateria: TiposBaterias | null) => {
  const tiposPermitidos = getTiposPermitidos(baterias)
  const somenteLitio = tiposPermitidos.includes("litio") && !tiposPermitidos.includes("chumbo")
  const somenteChumbo = tiposPermitidos.includes("chumbo") && !tiposPermitidos.includes("litio")

  if (somenteLitio && tipo_bateria !== "litio") {
    return "Permitido nesta UF: Bateria de Lítio"
  }
  if (somenteChumbo && tipo_bateria !== "chumbo") {
    return "Permitido nesta UF: Bateria de Chumbo"
  }

  return ""
}

export const TipoBateriaInput = ({ errorState, formState, onChangeValue }: CiclosBateriasInputProps) => {
  const projetosOffGridStoreActions = useProjetosOffGridStore (store => store.actions)
  const projetosOffGridStoreStateValidations = useProjetosOffGridStore (store => store.state.validations)

  const helperText = useMemo(()=>{
    if (!formState?.tipo_bateria) return projetosOffGridStoreStateValidations.tipo_bateria.helper || ""
    if (formState.baterias.length > 0) {
      return checarBaterias(formState.baterias, formState.tipo_bateria?.id || null)
    }
    
    return ""
  },[formState.tipo_bateria, formState.baterias, projetosOffGridStoreStateValidations.tipo_bateria.helper])

  const options = useMemo(()=>{
    const tiposPermitidos = getTiposPermitidos(formState.baterias)
    return TIPOS_BATERIAS_OPTIONS.filter(bt => tiposPermitidos.includes(bt.id))
  },[formState.baterias])

  useEffect(()=>{
    projetosOffGridStoreActions.changeValidationsValue({ tipo_bateria: { status: !helperText, helper: helperText } })
  },[helperText, projetosOffGridStoreActions])

  return (
    <InputComboBoxList
      id={"offgrid-tipo-bateria-field"}
      key={`offgrid-tipo-bateria-field`}
      label={"* Tipo de Bateria"}
      textField="nome"
      prefix={<InputPrefix />}
      valueField="id"
      error={!!projetosOffGridStoreStateValidations.tipo_bateria.helper || !!helperText || errorState.includes('tipo_bateria')}
      helperText={projetosOffGridStoreStateValidations.tipo_bateria.helper || helperText}
      options={options}
      value={formState?.tipo_bateria || null}
      renderOptions={(option: any) => {
        return `${option?.nome}`
      }}
      renderOptionsLabel={(option: any) => {
          return `${option?.nome}`
        }}
      onChange={(value) => {
        const payload = { tipo_bateria: value, recalcular: true };
        
        if (value?.id === 'litio' && OPCOES_REMOVER_LITIO.includes(formState.tensao_saida?.id || "")) {
          Object.assign(payload, { tensao_saida: null })
        } 

        onChangeValue(payload)
      }}
    />
  )
}